import {tva} from "@gluestack-ui/nativewind-utils/tva";

export const iconStyle = tva({
    base: "text-typography-950 fill-none stroke-transparent pointer-events-none",
    variants: {
        size: {
            "4xs": "h-2 w-2",
            "3xs": "h-2.5 w-2.5",
            "2xs": "h-3 w-3",
            xs: "h-3.5 w-3.5",
            sm: "h-4 w-4",
            md: "h-5 w-5",
            lg: "h-6 w-6",
            xl: "h-7 w-7",
            "2xl": "h-8 w-8",
            "3xl": "h-9 w-9"
        },
        // TODO: remove as soon as fully migrated to gluestack-ui
        // for old props compatibility
        color: {
            white: "fill-white",
            "primary.600": "fill-blue-600",
            "blueGray.600": "fill-blueGray-600",
            "blueGray.400": "fill-blueGray-400",
            "blue.600": "fill-blue-600",
            "error.600": "fill-error-600",
            "red.500": "fill-red-500",
            "success.500": "fill-success-500",
            "success.600": "fill-success-600"
        },
        fill: {
            white: "fill-white",
            "primary.600": "fill-blue-600",
            "blueGray.600": "fill-blueGray-600",
            "blueGray.400": "fill-blueGray-400",
            "blueGray.200": "fill-blueGray-200",
            "blueGray.800": "fill-blueGray-800",
            "red.500": "fill-red-500",
            "success.500": "fill-success-500",
            "danger.500": "fill-danger-500",
            "teal.600": "fill-teal-600",
            "success.600": "fill-success-600",
            "error.600": "fill-error-600",
            "warning.600": "fill-warning-600",
            Airbnb: "fill-Airbnb",
            Booking: "fill-Booking",
            HomeAway: "fill-HomeAway",
            Houfy: "fill-Houfy",
            ChannelConnector: "fill-ChannelConnector",
            August: "fill-August",
            Seam: "fill-Seam",
            direct: "fill-direct",
            internal: "fill-internal"
        },
        stroke: {
            "primary.600": "stroke-blue-600",
            "blueGray.600": "stroke-blueGray-600",
            "blueGray.800": "stroke-blueGray-800",
            "blueGray.400": "stroke-blueGray-400"
        }
    }
});
